<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import TimeOffDetail from '../../../../time-off/components/TimeOffDetail.vue'
import { TimeOffRequestID } from '../../../../time-off/models/timeOffRequest'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
        childNavItems: [
            {
                label: 'Employees',
                route: '/(app)/people/employees/',
            },
            {
                label: 'Availability',
                route: '/(app)/people/availability/',
            },
            {
                label: 'Broadcasts',
                route: '/(app)/people/broadcasts/',
            },
            {
                label: 'Time Off',
                route: '/(app)/people/time-off/',
            },
        ],
    }
})

const {
  id,
} = defineProps<{
    id: TimeOffRequestID
}>()
</script>

<template>
  <TimeOffDetail
    :id="id"
  />
</template>